import React from "react";

// TODO Not actuall being used
const EmptyDrop = () => {
    return <div></div>;
};

export default EmptyDrop;
